import { Form, Select } from 'components/common'

function DiscountStatus({ status }) {
  return (
    <Form.Item
      name={'status'}
      label={'ステータス'}
      initialValue={status}
      rules={[
        {
          required: true,
          message: 'ステータスは必須です。',
        },
      ]}
    >
      <Select
        options={[
          { value: 'ACTIVE', label: 'アクティブ' },
          { value: 'ARCHIVED', label: 'アーカイブ' },
        ]}
      />
    </Form.Item>
  )
}

export default DiscountStatus
